<template>
  <div class="jwl-home container">
    <h1 class="jwl-home__headline">
      {{$t('home.welcome', { user: moduleStore.currentUser.firstName })}}
    </h1>

    <div class="jwl-divider" />

    <HomeOrientation />

    <div class="jwl-divider" />

    <HomeSocialRow />

    <div class="jwl-divider" />

    <div class="jwl-home__row" v-if="isAuthorised(rolesAndRightsList.RIGHT__ANNOUNCEMENT__DISPLAY, false)">
      <h2 class="jwl-home__headline-column" v-t="'home.announcements.headline'" />

      <div class="jwl-home__text-column">
        <AnnouncementBox />
      </div>
    </div>

    <div class="jwl-divider" />

    <div class="jwl-home__row" v-if="isAuthorised(rolesAndRightsList.RIGHT__HOME_GRADER__DISPLAY, false)">
      <h2 class="jwl-home__headline-column" v-t="'home.facilitatorGrading.headline'" />

      <div class="jwl-home__text-column">
        <FacilitatorGradingOverview />
      </div>
    </div>

    <div class="jwl-divider" />

    <div class="jwl-home__row" v-if="isAuthorised(rolesAndRightsList.RIGHT__HOME_ACTIVE_COURSES__DISPLAY, false)">
      <h2 class="jwl-home__headline-column" v-t="'home.courseStatus.headline'" />

      <div class="jwl-home__text-column" v-if="concentrations">
        <ProfileProgrammeStatus
          v-for="concentration in concentrations"
          :run-concentration="concentration"
          :only-active-course=true
          :key="concentration.id" />
      </div>
      <div class="container" v-else>
        <JwlIcon loading-icon class="icon-big" />
      </div>
    </div>
  </div>
</template>

<script setup>
  const { isAuthorised, rolesAndRightsList } = useUserAuthorisation();

  const moduleStore = useModuleStore();

  const concentrations = computed(() => moduleStore.baseConcentrations?.dataAsFlatArray());
</script>

<style lang="scss">
@use '@base/styles/variables';
@use '@base/styles/mixins';

.jwl-home {
  --page-color: var(--color-blue);

  &__headline {
    margin: 3rem 0;
  }

  &__row {
    align-items: flex-start;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    margin-bottom: 2.5rem;

    @include mixins.mq(variables.$mq-tablet) {
      flex-flow: row wrap;
    }
  }

  &__headline-column {
    flex: 0 0 12rem;
    margin: 1.5rem 0;
  }

  &__text-column {
    flex: 1 0 100%;
    margin-top: 1.5rem;
    max-width: 100%;

    p {
      margin: 0 0 .5rem;
    }
  }

  &__column-link {
    color: var(--color-blue);
    display: inline-block;
    margin-left: .3rem;
  }
}
</style>
